import { render } from "./ApprovalsListCardPrice.vue?vue&type=template&id=4962fe31"
import script from "./ApprovalsListCardPrice.vue?vue&type=script&lang=js"
export * from "./ApprovalsListCardPrice.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__